module.exports = __webpack_public_path__ + "SP_SPS2-FavoriteToy-1795d0b62dc9d47cb9d24c6439b5482a.png";